import { Inject, Injectable } from '@angular/core';
import { API_ROOT_TOKEN, IS_LOCALHOST_TOKEN } from '../../../../injection-tokens';
import { environment } from '../../../../../environments/environment';

export interface StreamingConfig {
    baseUrl: string;
    streamingEndpoint: string;
}

@Injectable({
    providedIn: 'root'
})
export class StreamingConfigService {
    private readonly config: StreamingConfig;

    constructor(
        @Inject(API_ROOT_TOKEN) private readonly apiRoot: string,
        @Inject(IS_LOCALHOST_TOKEN) private readonly isLocalhost: boolean
    ) {
        if (this.isLocalhost) {
            if (environment.isLocalBackend) {
                // npm run local: Use local backend endpoint
                this.config = {
                    baseUrl: '', // Empty - proxy handles routing
                    streamingEndpoint: '/api/local/responses-agent/stream'
                };
            } else {
                // npm run start: Use remote dev backend endpoint
                this.config = {
                    baseUrl: '', // Empty - proxy handles routing
                    streamingEndpoint: '/api/responses-agent/stream'
                };
            }
        } else {
            // Hosted environments (dev/prod): Use direct backend URLs
            this.config = {
                baseUrl: this.apiRoot,
                streamingEndpoint: `${this.apiRoot}/responses-agent/stream`
            };
        }

        // console.log('🔧 StreamingConfig initialized:', this.config);
        // console.log('🔧 Runtime Environment - isLocalhost:', this.isLocalhost, 'apiRoot:', this.apiRoot);
    }

    getStreamingEndpoint(): string {
        return this.config.streamingEndpoint;
    }

    getBaseUrl(): string {
        return this.config.baseUrl;
    }

    getConfig(): StreamingConfig {
        return { ...this.config };
    }
}
